import { registerCookieLogging } from './utils';
import ProductButtonMediator from './ProductButtonMediator';

/**
 * USAGE:
 *
 * $(document).ready(function() {
 *   const buttons = $('body').colibriProductButtons();
 * });
 *
 * $('body').colibriProductButtons({
 *    selector: '.custom-colibri-product-button'
 * });
 */
( function( $ ) {
	'use strict';

	// Define the plugin
	$.fn.colibriProductButtons = function( options ) {
		const settings = $.extend( {
			selector: '.colibri-product-button',
			labels: null
		}, options );

		// Register cookie logging
		registerCookieLogging();

		// Create a single instance of the mediator (Singleton pattern)
		if ( !$.fn.colibriProductButtons.mediatorInstance ) {
			$.fn.colibriProductButtons.mediatorInstance = new ProductButtonMediator( settings );
		}
		const mediator = $.fn.colibriProductButtons.mediatorInstance;

		// Define methods for the plugin
		const methods = {
			init: function( $containers = null ) {
				// Initialize mediator with either the provided container or all matched containers
				mediator.initialize( $containers || $( settings.selector ) );
			},
			initAddToCart: function( event, newContainer ) {
				// Initialize the specified instances of 'ProductActionButton' within the given wrapper
				if ( event.originalEvent instanceof CustomEvent ) {
					newContainer = $( event.originalEvent.detail || null );
				}
				methods.init( newContainer );
			},
			initAllAddToCarts: function( event, $wrapper ) {
				// Initialize all instances of 'ProductActionButton' within the given wrapper
				const $containers = $wrapper.find( settings.selector );
				if ( !$containers.length ) return;
				$containers.each( ( _, candidate ) => methods.init( $( candidate ) ) );
			},
			unindexAddToCart: function( event, container ) {
				// Remove the specified instance of 'ProductActionButton'
				if ( event.originalEvent instanceof CustomEvent ) {
					container = $( event.originalEvent.detail || null );
				}

				const productCode = container.data( 'product-code' );
				if ( productCode ) {
					mediator.unregister( productCode, container );
				}
			}
		};

		// Automatically call init when the plugin is invoked
		this.init();

		// Store methods in the jQuery data storage to allow external access
		this.data( 'colibriProductButtons', methods );

		// Return the jQuery object to maintain chainability
		return this;
	};

	// Make the plugin's methods globally accessible
	$.extend( {
		colibriProductButtons: function() {
			return $( 'body' ).data( 'colibriProductButtons' );
		}
	} );
} )( jQuery );
